export const CACHE_TTL = {
    ONE_DAY: 24 * 3600 * 1000,
    ONE_MIN: 60 * 1000,
    ONE_HOUR: 3600 * 1000,
    FIVE_MIN: 300 * 1000,
};
